export enum FormInputType {
  Text,
  Number,
  Email,
  Date,
  Time,
  TextArea,
  Code,
  Checkbox,
  Select
}
